import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { Inject, Injectable, LOCALE_ID, OnDestroy, PLATFORM_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router,  } from "@angular/router";
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from "rxjs/internal/Subject";
import { catchError, map, takeUntil } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { News } from "../models/news";
import { CanonicalService } from "../services/canonical.service";
import { JsonldService } from "../services/jsonld.service";
import { MetaSeoService } from "../services/meta-seo.service";
import { NewsService } from "../services/news.service";
import { ErrorMsg } from "../utils/error-msg";

@Injectable({
    providedIn: 'root',
  })
  export class CompanyNewsDetailResolver implements Resolve<News>,OnDestroy {
    destroy$: Subject<boolean> = new Subject<boolean>();
    
    constructor(
      @Inject(LOCALE_ID) private localId: Object,
      @Inject(PLATFORM_ID) private platformId: Object,
      private canonicalService: CanonicalService,
      private newsService:NewsService,
      private seoService:MetaSeoService,
      public jsonldService: JsonldService,
      private router: Router,
    ){}
     
    ngOnDestroy(): void {
      this.destroy$.next(true);
      this.destroy$.unsubscribe();
    }

    resolve(route: ActivatedRouteSnapshot): Observable<News> {
      if (isPlatformBrowser(this.platformId)||isPlatformServer(this.platformId)) {
        const urlParam = route.paramMap.get('id');
        const subSuffex="/company-news/"
        const domain=environment.domain;
        const lang=(this.localId+"").substring(0,2);        
        let domainAndLangURL=domain+"/"+lang;
        let noIndex="noindex";
       
        return  this.newsService.getByUrl(urlParam).pipe(
          takeUntil(this.destroy$),
          map(a => {
            if (!a) {
              this.router.navigate(['/404']);
             }
            let info = a as News;           
            let title="Şirket Haberleri - ";
            let description="Şirket Haberleri -"+info?.title;
            if(lang!="tr"){
              title="Şirket Haberleri - ";
              description="Şirket Haberleri -"+info?.title;
            }
            let canonicalURL = domain+"/"+lang+subSuffex+urlParam;
            this.canonicalService.setCanonicalURLForId(canonicalURL);      
            this.seoService.setMetaAndTitle(title,description,canonicalURL,domainAndLangURL,noIndex);
            this.canonicalService.setOnlyAlternateDefault(canonicalURL);
            this.jsonldService.setArticle(info.title ,info.createDate,info.subTitle);
            return info;
          }),
          catchError(err => ErrorMsg.handleError(this.router,err))
          )
        }
    }
}
